import { useEffect, useRef } from "react";

/**
 * Runs `onSignOut` when a take-off source loses its session, seeded from the mount-time value so it
 * does not fire on a list that mounts already signed out.
 *
 * The lists stay mounted behind `TakeOffLogin` rather than unmounting, so without this a sign-out and
 * sign-in — possibly as a different account — leaves the previous account's selection and prefill
 * flags in place. `useConnectionTransition` does not cover it: signing out of a selector session never
 * passes through `connected`, so nothing there fires.
 */
export const useSignOutReset = (isAuthenticated: boolean, onSignOut: () => void) => {
  const wasAuthenticated = useRef<boolean>(isAuthenticated);
  const onSignOutRef = useRef(onSignOut);
  onSignOutRef.current = onSignOut;

  useEffect(() => {
    if (!isAuthenticated && wasAuthenticated.current) onSignOutRef.current();
    wasAuthenticated.current = isAuthenticated;
  }, [isAuthenticated]);
};

export default useSignOutReset;
